<template>
  <div class="min-h-screen bg-[#0d0d17]">
    <RouterView />
  </div>
</template>

<script setup>
</script>
